export const externalQuoteTheme = {
  colors: {
    headerPurple: '#6B46C1',
    headerText: '#FFFFFF',
    primaryBlue: '#0066CC',
    borderGray: '#E5E5E5',
    lightGray: '#F5F5F5',
    textPrimary: '#333333',
    textSecondary: '#666666',
    successGreen: '#4CAF50',
    warningOrange: '#FF9800',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
  fontSize: {
    xs: '11px',
    sm: '12px',
    md: '14px',
    lg: '16px',
    xl: '18px',
  },
  borderRadius: {
    sm: '4px',
    md: '6px',
  },
};
